import { createSlice } from "@reduxjs/toolkit";
/* eslint-disable no-param-reassign */
const initialState = {
  type: "A",
  keyword: "",
  status: "",
  overDue: "",
  statusDays: "",
  followDays: "",
  targetDate: "",
  assignee: "",
  practiceName: "",
  priority: "",
  internalAssignee: "",
  teamCategory: "",
  customerId: "",
  mergeCustomerId: "",
  clientCustomerId: "",
  clientStatus: "",
  clientId: "",
  team: "",
  suspended: "",
  userType: "",
  cp: "",
  appUser: "",
  reseller: "",
  entityId: "",
  priorityClient: "",
  fromDate: "",
  toDate: "",
  reporter: "",
  impManger: "",
  ticketCategory: "",
  currentPage: 1,
};

export const ticketTaskFilterSlice = createSlice({
  name: "ticketTaskFilter",
  initialState,
  reducers: {
    setType: (state, action) => {
      state.type = action.payload;
    },
    setKeyword: (state, action) => {
      state.keyword = action.payload;
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setOverDue: (state, action) => {
      state.overDue = action.payload;
    },
    setStatusDays: (state, action) => {
      state.statusDays = action.payload;
    },
    setFollowDays: (state, action) => {
      state.followDays = action.payload;
    },
    setTargetDate: (state, action) => {
      state.targetDate = action.payload;
    },
    setAssignee: (state, action) => {
      state.assignee = action.payload;
    },
    setPracticeName: (state, action) => {
      state.practiceName = action.payload;
    },
    setPriority: (state, action) => {
      state.priority = action.payload;
    },
    setInternalAssignee: (state, action) => {
      state.internalAssignee = action.payload;
    },
    setTicketCustomerId: (state, action) => {
      state.customerId = action.payload;
    },

    setMergeTicketCustomerId: (state, action) => {
      state.mergeCustomerId = action.payload;
    },

    setClientCustomerId: (state, action) => {
      state.clientCustomerId = action.payload;
    },

    setClientStatus: (state, action) => {
      state.clientStatus = action.payload;
    },

    setClientId: (state, action) => {
      state.clientId = action.payload;
    },
    setTeam: (state, action) => {
      state.team = action.payload;
    },
    setUserType: (state, action) => {
      state.userType = action.payload;
    },
    setCp: (state, action) => {
      state.cp = action.payload;
    },
    setAppUser: (state, action) => {
      state.appUser = action.payload;
    },
    setPriorityClient: (state, action) => {
      state.priorityClient = action.payload;
    },
    setReseller: (state, action) => {
      state.reseller = action.payload;
    },
    setEntityId: (state, action) => {
      state.entityId = action.payload;
    },
    setReporter: (state, action) => {
      state.reporter = action.payload;
    },
    setImpManager: (state, action) => {
      state.impManger = action.payload;
    },
    setTicketCategory: (state, action) => {
      state.ticketCategory = action.payload;
    },

    setTeamCategory: (state, action) => {
      state.teamCategory = action.payload;
    },

    setFromDate: (state, action) => {
      state.fromDate = action.payload;
    },
    setToDate: (state, action) => {
      state.toDate = action.payload;
    },
    setPageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },

    setSortName: (state, action) => {
      state.sortName = action.payload;
    },
    setSortOrder: (state, action) => {
      state.sortOrder = action.payload;
    },

    setSuspended: (state, action) => {
      state.suspended = action.payload;
    },

    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },

    clearTicketTaskFilters: (state) => {
      state.type = "Ticket";
      state.keyword = "";
      state.status = "I";
      state.overDue = "";
      state.statusDays = "";
      state.followDays = "";
      state.targetDate = "";
      state.assignee = "";
      state.practiceName = "";
      state.priority = "";
      state.internalAssignee = "";
      state.customerId = "";
      state.clientId = "";
      state.team = "";
      state.userType = "";
      state.mergeCustomerId = "";
      state.cp = "";
      state.suspended = "";
      state.appUser = "";
      state.reseller = "";
      state.entityId = "";
      state.reporter = "";
      state.impManger = "";
      state.ticketCategory = "";
      state.fromDate = "";
      state.toDate = "";
      state.teamCategory = "";
      state.currentPage = 1;
    },
    setTicketTaskAllFilters: (state, action) => {
      state.type = action.payload.type;
      state.keyword = action.payload.keyword;
      state.status = action.payload.status;
      state.overDue = action.payload.overDue;
      state.statusDays = action.payload.statusDays;
      state.followDays = action.payload.followDays;
      state.targetDate = action.payload.targetDate;
      state.assignee = action.payload.assignee;
      state.practiceName = action.payload.practiceName;
      state.priority = action.payload.priority;
      state.mergeCustomerId = action.payload.customerId;
      state.internalAssignee = action.payload.internalAssignee;
      state.customerId = action.payload.customerId;

      state.clientId = action.payload.clientId;
      state.team = action.payload.team;
      state.userType = action.payload.userType;
      state.priorityClient = action.payload.priorityClient;
      state.cp = action.payload.cp;
      state.appUser = action.payload.appUser;
      state.reseller = action.payload.reseller;
      state.entityId = action.payload.entityId;
      state.impManger = action.payload.impManger;
      state.reporter = action.payload.reporter;
      state.ticketCategory = action.payload.ticketCategory;
      state.suspended = action.payload.suspended;
      state.fromDate = action.payload.fromDate;
      state.toDate = action.payload.toDate;
      state.teamCategory = action.payload.teamCategory;
      state.currentPage = action.payload.currentPage;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setType,
  setKeyword,
  setStatus,
  setOverDue,
  setStatusDays,
  setFollowDays,
  setTargetDate,
  setAssignee,
  setPracticeName,
  setPriority,
  setInternalAssignee,
  setTicketCustomerId,
  setMergeTicketCustomerId,
  setPriorityClient,
  setClientId,
  setTeam,
  setUserType,
  setCp,
  setAppUser,
  setReseller,
  setEntityId,
  setReporter,
  setFromDate,
  setToDate,
  setCurrentPage,
  setImpManager,
  clearFilters,
  setTeamCategory,
  setClientCustomerId,
  setClientStatus,
  clearTicketTaskFilters,
  setTicketTaskAllFilters,
} = ticketTaskFilterSlice.actions;

export default ticketTaskFilterSlice.reducer;
